import React, { useState, useEffect } from 'react';

/**
 * FallingPlaceholders Component
 * Demonstrates React working with animated falling placeholder cards
 */
function FallingPlaceholders() {
    const [cards, setCards] = useState([]);
    const [nextId, setNextId] = useState(0);

    useEffect(() => {
        // Create new falling card every 800ms
        const interval = setInterval(() => {
            const newCard = {
                id: nextId,
                x: Math.random() * 80, // Random horizontal position (0-80%)
                animationDuration: 3 + Math.random() * 2, // 3-5 seconds
                delay: 0,
                color: getRandomColor()
            };
            
            setCards(prev => [...prev, newCard]);
            setNextId(prev => prev + 1);

            // Remove card after animation completes
            setTimeout(() => {
                setCards(prev => prev.filter(card => card.id !== newCard.id));
            }, (newCard.animationDuration + 0.5) * 1000);
        }, 800);

        return () => clearInterval(interval);
    }, [nextId]);

    function getRandomColor() {
        const colors = [
            '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', 
            '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'
        ];
        return colors[Math.floor(Math.random() * colors.length)];
    }

    const containerStyle = {
        position: 'relative',
        width: '100%',
        height: '600px',
        backgroundColor: '#f8f9fa',
        overflow: 'hidden',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
    };

    const cardStyle = (card) => ({
        position: 'absolute',
        top: '-100px',
        left: `${card.x}%`,
        width: '120px',
        height: '150px',
        backgroundColor: card.color,
        borderRadius: '8px',
        padding: '15px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
        animation: `fall ${card.animationDuration}s ease-in forwards`,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    });

    const placeholderLine = {
        backgroundColor: 'rgba(255,255,255,0.6)',
        height: '12px',
        borderRadius: '4px',
        animation: 'pulse 1.5s ease-in-out infinite'
    };

    return (
        <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ fontSize: '32px', fontWeight: 'bold', marginBottom: '10px' }}>
                    🎉 React is Working!
                </h2>
                <p style={{ fontSize: '18px', color: '#666' }}>
                    Watch the placeholder cards fall from the sky
                </p>
            </div>

            <div style={containerStyle}>
                {cards.map(card => (
                    <div key={card.id} style={cardStyle(card)}>
                        <div style={{ ...placeholderLine, width: '80%' }}></div>
                        <div style={{ ...placeholderLine, width: '60%' }}></div>
                        <div style={{ ...placeholderLine, width: '90%' }}></div>
                        <div style={{ ...placeholderLine, width: '70%', marginTop: 'auto' }}></div>
                    </div>
                ))}
            </div>

            <style>{`
                @keyframes fall {
                    0% {
                        top: -100px;
                        transform: rotate(0deg);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    100% {
                        top: 650px;
                        transform: rotate(${Math.random() * 360}deg);
                        opacity: 0.8;
                    }
                }

                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.5;
                    }
                }
            `}</style>

            <div style={{ 
                marginTop: '30px', 
                padding: '20px', 
                backgroundColor: '#e8f5e9', 
                borderRadius: '8px',
                border: '2px solid #4caf50'
            }}>
                <h3 style={{ margin: '0 0 10px 0', color: '#2e7d32' }}>✅ Success!</h3>
                <p style={{ margin: 0, color: '#1b5e20' }}>
                    If you see falling cards above, React is fully integrated and working in your Ghost theme!
                </p>
            </div>
        </div>
    );
}

export default FallingPlaceholders;
